module.exports = __webpack_public_path__ + "static/img/cabinet24_13.5f496eb7.gif";